document.addEventListener('DOMContentLoaded', () => {
  const locale = (document.documentElement.lang || '').toLowerCase();
  if (!locale.startsWith('fr')) return;

  const home = document.querySelector('.pha');
  if (!home) return;

  const eyebrow = home.querySelector('.pha-eyebrow');
  const lede = home.querySelector('.pha-lede');
  const primaryCTA = home.querySelector('.pha-hero .pha-cta');
  const topBar = home.querySelector('.pha-bar');

  if (eyebrow) eyebrow.textContent = 'Caspirolus · Le geste éco du quotidien';
  if (lede) lede.textContent = 'Un lot de 5 essuie-tout lavables épais, absorbants et réutilisables, avec des motifs chats qui égayent la cuisine.';
  if (primaryCTA) primaryCTA.innerHTML = 'Choisir votre motif — 19,99 € <span class="pha-leaf">🌿</span>';
  if (topBar) topBar.innerHTML = '<span>🚚 Livraison offerte en France</span><span class="c">−10 % avec CASPIROLUS10</span>';

  if (lede && !home.querySelector('.pha-offer-proof')) {
    const offer = document.createElement('div');
    offer.className = 'pha-offer-proof';
    offer.innerHTML = '<div><b>5 feuilles épaisses de 380 g/m²</b><span>25 × 25 cm · lavables en machine · livraison offerte</span></div><strong>19,99 €</strong>';
    lede.after(offer);
  }

  home.querySelectorAll('.pha-sec').forEach((section) => {
    if (section.querySelector('.pha-revs')) section.remove();
  });

  const guarantee = home.querySelector('.pha-guar p');
  if (guarantee) guarantee.textContent = 'Nous sommes convaincus que vous allez les adorer. Sinon, vous bénéficiez de notre garantie satisfait ou remboursé pendant 30 jours.';

  const newsletterTitle = home.querySelector('.pha-nl h2');
  const newsletterInput = home.querySelector('.pha-nl input[type="email"]');
  if (newsletterTitle) newsletterTitle.textContent = 'Rejoignez le club Caspirolus';
  if (newsletterInput) newsletterInput.placeholder = 'Votre e-mail';
});
